import { handleDemoRequest } from "./handleDemoRequest";

export function installDemoFetchMocks() {
  if (typeof window === "undefined" || typeof window.fetch !== "function") return;
  if (window.__demoFetchInstalled) return;
  window.__demoFetchInstalled = true;

  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input, init = {}) => {
    let urlRaw = "";
    if (typeof input === "string") urlRaw = input;
    else if (input && typeof input === "object") urlRaw = input.url || "";

    const isDemo = (() => {
      try {
        return localStorage.getItem("isDemo") === "1";
      } catch (e) {
        return false;
      }
    })();

    if (!isDemo) return originalFetch(input, init);

    const url = String(urlRaw || "").replace(/^\//, "");
    const method = (init.method || "GET").toUpperCase();

    // Keep auth endpoints real even in demo mode (menu/permissions must be real & stable)
    if (url.startsWith("api/auth/")) {
      return originalFetch(input, init);
    }

    // Keep kindergarten registry/profile real even in demo mode
    if (url === "api/kindergarten/kindergartens" || url.startsWith("api/kindergarten/profile/")) {
      return originalFetch(input, init);
    }

    // Keep electronic queue registry real even in demo mode
    if (url.startsWith("api/kindergarten/equeue/")) {
      return originalFetch(input, init);
    }

    let body = init.body;
    if (typeof body === "string") {
      try {
        body = JSON.parse(body);
      } catch (e) {
      }
    }

    const res = await handleDemoRequest({ method, url, body });
    return new Response(JSON.stringify(res.data), {
      status: res.status,
      headers: { "Content-Type": "application/json" },
    });
  };
}

